import { Component, OnInit, Inject } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-update-preauth-modal',
  templateUrl: './update-preauth-modal.component.html',
  styleUrls: ['./update-preauth-modal.component.css']
})
export class UpdatePreauthModalComponent implements OnInit {
  loading:boolean=false;submitted:boolean=false;lead={lead_name:'',mobile:''};dataLoaded:boolean=false;myrole:string; s3url='';doc_type:string;uploading:boolean=false;allUploads=[];fileDeleting:boolean = false;InsurancePreauthForm: FormGroup;hospitals=[];hospitals_copy=[];preauth_loading:boolean=false;preauth_submitted:boolean=false;disableArrivalPastDate:any;UserId:any;uploaddataLoaded:boolean=false;doctors=[];doctors_copy=[];
  constructor(public dialogRef: MatDialogRef<UpdatePreauthModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,
  private router:Router,private sharedapi:SharedService, private leadapi:LeadsService, private formBuilder: FormBuilder) { 
    this.InsurancePreauthForm = this.formBuilder.group({
      'preauth_arrival_date_time' : [null, Validators.required],
      'preauth_hospital_id' : [null, Validators.required],
      'preauth_doctor_id' : [null, Validators.required],
    });
  }
  get f() { return this.InsurancePreauthForm.controls; }

  ngOnInit(): void {
    this.sharedapi.getRole()
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.s3url = localStorage.getItem('s3url');
    this.UserId = localStorage.getItem('loginuserId');
    this.getPreauthInsuranceDetails();
    this.getHospital();
    if(this.myrole=='1' || (this.myrole=='3' && (this.UserId=='73' || this.UserId=='1'))){
      this.disableArrivalPastDate = false;
    }else{
        this.disableArrivalPastDate = new Date().toISOString().slice(0, 16);
    }
  }

  getPreauthInsuranceDetails()
  {

      this.dataLoaded = false;
      this.leadapi.getPreAuthInsuranceDetails(this.data,'1').subscribe(
      (data:any) => {
          this.dataLoaded = true;
          if(data.lead)
          {
            this.lead = data.lead;
            /* if((data.lead.circle_id==2 || data.lead.circle_id==3 || data.lead.circle_id==6) && (data.lead.treatment_id==2 || data.lead.treatment_id==19 || data.lead.treatment_id==20 || data.lead.treatment_id==21 || data.lead.treatment_id==24 || data.lead.treatment_id==52 || data.lead.treatment_id==85 || data.lead.treatment_id==39 || data.lead.treatment_id==15 || data.lead.treatment_id==16 || data.lead.treatment_id==96)){
              this.getTreatmentwiseDoc(data.lead.circle_id,data.lead.treatment_id,'');
            }else{
                this.getDoctor();
            } */
            this.getDoctor();
          }
          if(data && data.status)
          {
            this.allUploads = data.uploads;
          }
          if(data.data){
            if(data.data.preauth_hospital_id && data.data.preauth_arrival_date_time) {
              this.uploaddataLoaded = true;
            }
            this.InsurancePreauthForm.controls['preauth_hospital_id'].setValue(data.data.preauth_hospital_id);
            this.InsurancePreauthForm.controls['preauth_arrival_date_time'].setValue(data.data.preauth_arrival_date_time);
            this.InsurancePreauthForm.controls['preauth_doctor_id'].setValue(data.data.preauth_doctor_id);
          }
      },
      error => {
          this.sharedapi.checkError(error);
      });
  }

  async getTreatmentwiseDoc(circle_id,treatment_id,olddocId)
  {
    await this.leadapi.gettreatdoctors(circle_id,treatment_id,olddocId).subscribe((data:any) => {
        if(data.status)
        {
            this.doctors = data.data;
            this.doctors_copy= this.doctors;
        }else{
            this.doctors = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getDoctor()
  {
    await this.leadapi.getdoctors().subscribe((data:any) => {
        if(data.status)
        {
            this.doctors = data.data;
            this.doctors_copy= this.doctors;
        }else{
            this.doctors = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async selectFile(event)
  {
    if(this.doc_type!=undefined)
    {
        this.uploading = true;
        let file = event.target.files.item(0);
        const formData = new FormData();  
        formData.append('upload_type', this.doc_type); 
        formData.append('file', file); 
        formData.append('sheetview_action', '1'); 
        await this.leadapi.uploadInsuranceFile(this.data,formData)
        .subscribe((data:any) => {
            this.uploading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('File uploaded Successful');
                this.getPreauthInsuranceDetails();
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.uploading = false
                this.sharedapi.checkError(error);
            });
    }else{
        this.sharedapi.presentToast('Please select Document Type');
    }
  }

  CloseModal(): void {
    this.dialogRef.close();
  }

  removeFileInsurance(fileId)
  {
      this.fileDeleting = true;
      this.leadapi.deleteInsuranceFiles(fileId).subscribe((data:any) => {
          this.fileDeleting = false;
          if(data.status)
          {
            this.getPreauthInsuranceDetails();
          }else{
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async updatePreauthDetails()
  {
    this.preauth_submitted = true;
    this.preauth_loading = true;
    // stop here if form is invalid
    if (this.InsurancePreauthForm.invalid) {
      this.preauth_loading = false;
      return;
    }
    await this.leadapi.updatePreauthData(this.data,this.InsurancePreauthForm.value).subscribe((data:any) => {
      this.preauth_submitted = false;
      this.preauth_loading = false;
      this.sharedapi.presentToast(data.msg);
      if(data.status){
        this.getPreauthInsuranceDetails();
      }
    }, error =>
    {
        this.sharedapi.checkError(error);
    });
  }

  async getHospital()
  {
      this.leadapi.gethospitals().subscribe((data:any) => {
          if(data.status)
          {
              this.hospitals = data.data;
              this.hospitals_copy= this.hospitals;
          }else{
              this.hospitals = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  setSearchValue(type){
    if(type=='doctor'){
      $("#doctorSearch").val('');
      $("#doctorSearch").focus();
      this.doctors= this.doctors_copy;
    }else if(type=='hospital'){
        $("#hospitalSearch").val('');
        $("#hospitalSearch").focus();
        this.hospitals= this.hospitals_copy;
    }
  }

  searchOnSelect(searchtText: string, type){
    if(type == 'doctor'){
      this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
    }else if(type == 'hospital'){
        this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
    }
  }
}
